import { Button, Group, Modal, Stack, Text } from '@mantine/core';
import { DateInput, DateValue } from '@mantine/dates';
import { IconCalendar } from '@tabler/icons-react';
import { useEffect, useState } from 'react';

type EditDateModalProps = {
  opened: boolean;
  onClose: () => void;
  onConfirm: (date: Date) => void;
  title: string;
  initialDate: Date | null;
  error?: { message: string } | null;
  isLoading: boolean;
};

export default function EditDateModal({
  opened,
  onClose,
  onConfirm,
  title,
  initialDate,
  error,
  isLoading,
}: EditDateModalProps) {
  const [date, setDate] = useState<Date | null>(initialDate);

  useEffect(() => {
    if (opened) {
      setDate(initialDate);
    }
  }, [opened, initialDate]);

  const handleConfirm = () => {
    if (date) {
      onConfirm(date);
    }
  };

  const handleDateChange = (value: DateValue) => {
    if (value instanceof Date) {
      setDate(value);
    } else if (typeof value === 'string') {
      setDate(new Date(value));
    } else {
      setDate(null);
    }
  };

  return (
    <Modal opened={opened} onClose={onClose} title={title} centered>
      <Stack gap="md">
        <DateInput
          label="Created at"
          value={date}
          onChange={handleDateChange}
          maxDate={new Date()}
          leftSection={<IconCalendar size={16} />}
          valueFormat="D MMMM YYYY"
          clearable
        />
        {error && <Text c="red">{error.message ?? 'An error occurred'}</Text>}
        <Group justify="flex-end">
          <Button variant="subtle" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleConfirm} loading={isLoading} disabled={!date}>
            Save
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
